import React, { useEffect } from 'react'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let deviceId = useDataValue({
    context: 'recorder',
    path: 'deviceId',
    viewPath: props.viewPath,
  })
  let changeDeviceVolume = useDataChange({
    context: 'recorder',
    path: 'deviceVolume',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    /** @type {ScriptProcessorNode | null} */
    let scriptProcessor = null

    async function run() {
      try {
        console.log({ deviceId })
        let stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            deviceId,
          },
        })
        let audioContext = new global.AudioContext()
        let analyser = audioContext.createAnalyser()
        let microphone = audioContext.createMediaStreamSource(stream)
        scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1)

        analyser.smoothingTimeConstant = 0.8
        analyser.fftSize = 1024

        microphone.connect(analyser)
        analyser.connect(scriptProcessor)
        scriptProcessor.connect(audioContext.destination)

        /** @type {number | null} */
        let lastValue = null
        scriptProcessor.onaudioprocess = function () {
          let array = new Uint8Array(analyser.frequencyBinCount)
          analyser.getByteFrequencyData(array)
          let arraySum = array.reduce((a, value) => a + value, 0)
          let average = Math.round(arraySum / array.length)
          if (average !== lastValue) {
            lastValue = average
            changeDeviceVolume(average)
          }
        }
      } catch (error) {
        console.error({ type: 'record/device-monitor', error })
      }
    }

    run()

    return () => {
      scriptProcessor?.disconnect()
    }
  }, [deviceId])

  return <View {...props} />
}
